module.exports = __webpack_public_path__ + "img/jet5_banner.18df5595.jpg";